<template>
  <div class="case-data">
    <div>
      <div class="condition">
        <div class="case-type">
          <span
            class="case-total"
            v-for="(item, index) in caseType"
            :key="index"
            @click="queryCaseType(index)"
            :class="{ 'case-actived': actived === index }"
          >
            {{ item }}
          </span>
        </div>
        <a href="javascript:void(0);" class="check-more"
          @click="showDetail">{{$t('top.common.viewDetails')}}<span class="check-icon"></span
        ></a>
      </div>
     
      <div class="date">
        <div
          class="date-item"
          v-for="(item, index) in date"
          :key="index"
          @click="queryDate(index)"
          :class="{ 'date-actived': activedDate === index }"
        >
          {{ item }}
        </div>
        <div class="select-date">
          <span class="date-scope">{{$t('top.common.range')}}</span>
          <el-date-picker
            class="date-picker"
            v-model="dateValue"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('top.common.dateStart')"
            :end-placeholder="$t('top.common.dateEnd')"
            value-format="yyyy-MM-dd"
            size="mini"
            @change="selectedDate"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="line-case">
      <div id="case"></div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      >
      <div class="case-type" slot="title" >
        <span
          class="case-total"
          style="height:fit-content;padding-bottom:6px;"
          v-for="(item, index) in caseType"
          :key="index"
          @click="queryCaseType(index)"
          :class="{ 'case-actived': actived === index }"
        >
          {{ item }}
        </span>
      </div>
      <div class="date" style="padding:0;">
        <div
          class="date-item"
          v-for="(item, index) in date"
          :key="index"
          @click="queryDate(index)"
          :class="{ 'date-actived': activedDate === index }"
        >
          {{ item }}
        </div>
        <div class="select-date">
          <span class="date-scope">{{$t('top.common.range')}}</span>
          <el-date-picker
            class="date-picker"
            v-model="dateValue"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('top.common.dateStart')"
            :end-placeholder="$t('top.common.dateEnd')"
            value-format="yyyy-MM-dd"
            size="mini"
            @change="selectedDate"
          >
          </el-date-picker>
        </div>
      </div>
    <div class="line-case">
      <div id="case1" style="height:400px;"></div>
    </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  props: {
    actived: {
      type: Number,
      default: 0,
    },
    activedDate: {
      type: Number,
      default: 0,
    },
    lineChartData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    lineChartData: {
      handler(newVal) {
        this.caseList = newVal;
        this.queryCaseData('case');
        if (this.dialogVisible) {
          this.queryCaseData('case1');
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      caseType: [this.$t('top.common.recruitingCases'), this.$t('top.common.newRecruitingCases')],
      date: [this.$t('top.common.sixMonths'), this.$t('top.common.oneYear'), this.$t('top.common.twoYear')],
      dateValue: "",
      myChart: null,
      caseList: [],
      dialogVisible:false,
    };
  },
  mounted() {
    this.queryCaseData('case');
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.myChart.resize();
    });
  },
  methods: {
    queryCaseData(id) {
      document.getElementById(id).removeAttribute('_echarts_instance_');
      const chartDom = document.getElementById(id);
      const myChart = this.$echarts.init(chartDom);
      this.myChart = myChart
      const option = {
        title: {
          text: this.$t('top.common.cases'),
          textStyle: {
            fontSize: 12,
            color:'#696969',
            fontWeight: '400'
          },
          top: "12",
          left: "29",
        },
        tooltip: {
          trigger: "axis",
          show: true,
          confine: true,
          backgroundColor: "#fff",
          extraCssText:
            "height: 69px;box-shadow:  0 2px 10px 0 rgba(180,180,180,0.50);padding: 12px 12px;box-sizing: border-box;",
          formatter:(params) =>{
            let htmlStr = `
          <div style='font-size:12px;font-weight: 500;color: #373C48;text-align:left;'>${params[0].name}</div>
          <p style='margin-top:8px;font-size:12px;color: #000000;text-align:left;'>${this.actived === 0?this.$t('top.common.recruitingCases'):this.$t('top.common.newRecruitingCases')}   ${params[0].data}</p>`;
            return htmlStr;
          },
        },
        legend: {},
        grid: {
          left: "52",
          right: "51",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            fontSize: 12,
            color: "#000000",
            opacity:'0.45'
          },
          axisLine:false,
          data: this.caseList.map((item) => item.groupDate),
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: 12,
            color: "#000000",
            opacity:'0.45'
          },
          axisLine:false,
        },
        series: [
          {
            name: "",
            type: "line",
            stack: "Total",
            showSymbol: false,
            symbol: "circle",
            smooth: true,
            itemStyle: {
              color: "#1890FF",
              lineStyle: {
                color: " #F3F3F3",
              },
            },
            lineStyle: {
              normal: {
                color: "#35C3FF",
                width: 1,
              },
            },
            data: this.caseList.map((item) => item.quantity),
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(205, 239, 255)" },
                  { offset: 1, color: "rgba(248, 252, 255)" },
                ]),
              },
            },
          },
        ],
      };
      option && this.myChart.setOption(option);
      window.addEventListener("resize", () => {
         setTimeout(() => {
            myChart.resize();
           }, 1000);
      });
    },
    queryCaseType(index) {
      this.$emit("queryCaseType", index);
    },
    queryDate(index) {
      this.dateValue = "";
      this.$emit("queryDate", index);
    },
    selectedDate() {
      this.$emit("selectedDate", this.dateValue);
    },
     showDetail() {
      this.dialogVisible = true;
      setTimeout(() => {
        this.queryCaseData('case1')
      }, 0)
    }
  },
};
</script>
<style scoped>
.case-data {
  height: 55%;
  margin-top: 12px;
}
.condition {
  height: 46px;
  padding: 0 21px 0 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #efefef;
}
.line-case {
  overflow: hidden;
  width: 100%;
  height: calc(100% - 128px);
}
#case {
  width: 100%;
  height: 100%;
}
.check-more {
  color: #999999;
  margin-left: 10px;
  text-decoration: none;
  font-size: 12px;
}
.check-icon {
  padding-left: 5px;
  padding-right: 7px;
  color: #999999;
  font-size: 12px;
  opacity: 0.6;
  position: relative;
}
.check-icon::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  border-top: 1px solid #999999;
  border-right: 1px solid #999999;
  transform: rotate(45deg);
  left: 1px;
  top: 6px;
}
.check-icon:hover {
  opacity: 1;
}
.case-type {
  display: flex;
  font-weight: 600;
  font-size: 16px;
  color: #373c48;
}
.case-total {
  margin-right: 40px;
  height: 48px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.case-actived {
  color: #1890ff !important;
  border-bottom: 4px solid #1890ff;
}
.date {
  display: flex;
  align-items: center;
  padding: 14px 0 4px 29px;
}
.date-item {
  padding: 5px 8px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 8px;
  border: 1px solid #dddddd;
  cursor: pointer;
}
.date-item:first-child{
  min-width: 64px;
  box-sizing: border-box;
}
.date-actived {
  background: #1890ff;
  color: #ffffff;
}
.select-date {
  display: flex;
  align-items: center;
}
.date-scope {
  font-size: 14px;
  color: #000000;
  margin-left: 12px;
  margin-right: 8px;
}
.date-picker {
  width: 208px;
  height: 28px;
}
</style>